import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';

export class ConfirmChangePasswordFormSession {
  clientContext: any;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  confirmPasswordComponent: ComponentRef<ConfirmPasswordComponent>;


  actionContext: any;
  submitHandler: any;
  mode: any;
  title: string;
  username: string;

  constructor(title, username){
      this.title = title;
      this.username = username;
      console.log(`Constructor title ${this.title}`);
      console.log(`Constructor username ${this.username}`);
  }

  startSession(
    description: com.ts.mobile.sdk.AuthenticatorDescription,
    mode: com.ts.mobile.sdk.AuthenticatorSessionMode,
    actionContext: com.ts.mobile.sdk.PolicyAction | null,
    clientContext: object | null
  ): void {
    console.log('Started Confirm change passwordTs session');
    this.actionContext = actionContext;
    this.clientContext = clientContext;
    this.mode = mode;

  }

  endSession(): void {
    console.log('Confirm Change passwordTs session ended');
  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<ResponseType>>{
    const self = this;
    self.resolver = (self.clientContext as any).resolver;
    self.viewContainerRef = (self.clientContext as any).viewContainerRef;
    self.viewContainerRef.clear();
   
    const userEmail = this.clientContext['cookieService'].get('userEmail');
    console.log('userEmail : ', userEmail);


    const factory: ComponentFactory<ConfirmPasswordComponent> = self.resolver.resolveComponentFactory(ConfirmPasswordComponent);
    self.confirmPasswordComponent = self.viewContainerRef.createComponent(factory);
    self.confirmPasswordComponent.instance.onResetPasswordSubmit = self.onResetPasswordSubmit;
    self.confirmPasswordComponent.instance.username = userEmail;


    self.confirmPasswordComponent.instance.onChangePasswordSkipClick = self.onChangePasswordSkipSubmit.bind(self);

    return new Promise((resolve, reject) => {
      self.submitHandler = (response) => {
        resolve(response);
      };
    });
  }

  promiseRecoveryForError(
    error: com.ts.mobile.sdk.AuthenticationError,
    validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>,
    defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery
  ): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    return new Promise((resolve, reject) => {
      const userEmail = this.clientContext['cookieService'].get('username');
      const newLocal = 'additional_data';
      const errorCode = error.getData()[newLocal]?.code;
      this.clientContext['cookieService'].set('passwordExpiry',errorCode, undefined, undefined, null, true, 'None');
      console.log('set password error code' + errorCode);
    });
  }

  onResetPasswordSubmit = (password: string) => {
    const inputResponse = com.ts.mobile.sdk.PasswordInput.create(password);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);
    this.submitHandler(response);
  }

  onChangePasswordSkipSubmit = () => {
    const changeConfirmPasswordEscapeOption = this.actionContext.getEscapeOptions()[0];
    if (!changeConfirmPasswordEscapeOption) {
        console.error(`unable to find a "change_confirm_password" escape option in actionContext.escapeOptions`);
    }
    else{
          this.submitHandler(com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(changeConfirmPasswordEscapeOption, new Object()));
    }
  }

}
export default ConfirmChangePasswordFormSession;
